module.exports = __webpack_public_path__ + "img/8.849572b.png";